export const INSIGHTS_SETTINGS_BASE = "/ad-studio/insights/settings";

/** The `:agentId` segment for the create-agent form. */
export const NEW_OPPORTUNITY_AGENT = "new";

export type InsightsSettingsPage = "sources" | "topics" | "opportunities";

/** `agentId` picks an opportunity agent; without one the page shows the first. */
export function insightsSettingsPath(
  page: InsightsSettingsPage,
  agentId?: string,
): string {
  const path = `${INSIGHTS_SETTINGS_BASE}/${page}`;
  return page === "opportunities" && agentId ? `${path}/${agentId}` : path;
}
